import HTTP from '@/config/axios-config-erp'

const ServiceVencimientos = {
  fGetSituaciones(empresa) {
    const payload = {
      visibleWebSN: 'S',
      empresa
    }
    return HTTP.post(`/wscomun/portalinformes/lovCos`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error)
      return { 'status': 500 }
    })
  },
  fGetSituacionesPagos(empresa) {
    const payload = {
      visibleWebSN: 'S',
      empresa
    }
    return HTTP.post(`/wscomun/portalinformes/lovPas`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error)
      return { 'status': 500 }
    })
  }
}

export default ServiceVencimientos



// WEBPACK FOOTER //
// ./src/services/srv-vencimientos.js